import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk'
import { TracingInstrumentation } from '@grafana/faro-web-tracing'

export default {
  install(Vue, options) {
    const faro = initializeFaro({
      url: FONTAWESOME.GRAFANA_FARO_COLLECTOR_URL,
      app: {
        name: 'fontawesome.com',
        version: FONTAWESOME.APP_VERSION,
        environment: FONTAWESOME.GRAFANA_FARO_COLLECTOR_ENVIRONMENT
      },
      sessionTracking: {
        samplingRate: parseFloat(FONTAWESOME.GRAFANA_FARO_COLLECTOR_SAMPLING_RATE),
        persistent: true
      },
      instrumentations: [
        // Mandatory, omits default instrumentations otherwise.
        ...getWebInstrumentations(),

        // Tracing package to get end-to-end visibility for HTTP requests.
        new TracingInstrumentation()
      ]
    })

    Vue.prototype.$faro = faro
  }
}
